import React from 'react';
import PublicNav from '../../components/PublicNav';
import { BackToHome } from '../../components/BackToHome';

const H2 = ({ children }) => (
  <h2 style={{ fontFamily: 'Cabinet Grotesk', fontSize: '1.25rem', fontWeight: 700, color: '#0076A3', marginTop: '2rem' }}>{children}</h2>
);

const Item = ({ title, body }) => (
  <div style={{ padding: '1rem 1.25rem', borderRadius: 12, border: '1px solid #ECE7DE', background: '#FAFBFC', marginBottom: '0.75rem' }}>
    <div style={{ fontWeight: 700, fontSize: '0.9375rem', color: '#0076A3', marginBottom: '0.25rem' }}>{title}</div>
    <div style={{ fontSize: '0.8125rem', color: '#64748B', lineHeight: 1.6 }}>{body}</div>
  </div>
);

export default function SecurityPage() {
  return (
    <div style={{ minHeight: '100vh', background: '#fff' }} data-testid="security-page">
      <PublicNav />
      <BackToHome testid="back-to-home-top" />
      <div style={{ maxWidth: 860, margin: '0 auto', padding: '3rem 2rem 4rem' }}>
        <h1 style={{ fontFamily: 'Cabinet Grotesk', fontSize: '2.25rem', fontWeight: 700, color: '#0076A3', marginBottom: '0.5rem' }}>Security &amp; Trust</h1>
        <p style={{ fontSize: '0.9375rem', color: '#718096', marginBottom: '2rem', maxWidth: 640 }}>
          Security and privacy are foundational to CHIRE. Below is an honest overview of our current security posture and our certification roadmap.
        </p>

        <div style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', padding: '0.5rem 1rem', borderRadius: 999, background: '#FFE7D9', color: '#0076A3', fontSize: '0.8125rem', fontWeight: 600, marginBottom: '2rem' }}>
          <span style={{ width: 8, height: 8, borderRadius: 999, background: '#0076A3' }} />
          SOC 2 Type II — readiness in progress
        </div>

        <H2>Data Protection</H2>
        <Item title="Encryption in transit & at rest" body="All traffic is served over TLS/HTTPS, and sensitive data (including biometric data) is encrypted at rest." />
        <Item title="Authentication" body="Sessions are protected using secure, httpOnly cookies (not accessible to JavaScript), reducing XSS token-theft risk. Passwords are hashed; brute-force protection via rate limiting." />
        <Item title="Access controls" body="Role-based access control (Super Admin, Admin, Recruiter, Candidate) with least-privilege data scoping across the platform." />
        <Item title="Rate limiting & abuse prevention" body="API rate limits on authentication, payments, and public endpoints to mitigate abuse and credential-stuffing." />

        <H2>Privacy & Compliance</H2>
        <Item title="Designed to support GDPR, DPDP 2023, BIPA, PDPL/PDPA" body="Consent management, biometric consent capture, data-subject request handling, and documented retention/destruction. These reflect product capabilities, not certifications." />
        <Item title="Biometric consent & retention" body="Explicit informed consent before any face capture; documented Biometric Data Retention & Destruction Policy." />
        <Item title="Data-subject requests" body="Individuals can submit access/deletion/correction requests routed to our Data Protection Officer." />

        <H2>Certifications Roadmap</H2>
        <Item title="SOC 2 Type II — In progress" body="We are working toward SOC 2 Type II attestation, the most widely requested control framework for B2B SaaS." />
        <Item title="ISO 27001 / 27701 — Planned" body="Information security and privacy information management certifications are on our roadmap." />

        <div style={{ marginTop: '2rem', padding: '1.25rem', borderRadius: 12, background: '#FAF7F2', border: '1px solid #F0EBE3' }}>
          <p style={{ fontSize: '0.8125rem', color: '#718096', margin: 0 }}>
            For security questionnaires, a Data Processing Agreement (DPA), or sub-processor information, contact{' '}
            <a href="mailto:connect@chire.co" style={{ color: '#0076A3' }}>connect@chire.co</a>.
          </p>
        </div>
      </div>
      <BackToHome testid="back-to-home-bottom" style={{ paddingBottom: '2.5rem' }} />
    </div>
  );
}
